import { Button, PageHeader } from 'components';
import { Form, Row, Col } from 'antd';
import styles from './style.module.scss';
import { CheckOutlined } from '@ant-design/icons';
import InfoSection from './formSections/info';
import DateSection from './formSections/date';
import DescriptionSection from './formSections/description';
import ShopSection from './formSections/shop';
import ImagesSection from './formSections/images';
import CheckboxesSection from './formSections/checkboxes';
import CommunicationsCheckboxes from './formSections/communicationsCheckboxes';

import { useTranslation } from 'react-i18next';

import useStoreEvents from '../useStoreEvents';
import NotificationFormForEdit from 'components/modules/notificationFormForEdit';

const EditStoreEvent = ({ isNew }) => {
  const { t } = useTranslation();
  const {
    singleItem,
    form,
    updateInProcess,
    handleCreateOrUpdate,
    handleApprove,
    filterData,
    handleDeleteFile,
    isShoppingCenter,
  } = useStoreEvents(false);

  const onFinish = async (params) => {
    await handleCreateOrUpdate(params);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const onClickSave = () => {
    form.submit();
  };

  const title = isNew
    ? t('PUBBLICA Eventi E Novità')
    : t('MODIFICA Eventi E Novità');

  const isApproveOnly = singleItem.can_approve && !singleItem.can_update;

  return (
    <div>
      <PageHeader title={title} />
      <div className={styles.content}>
        <Form
          form={form}
          name='basic'
          wrapperCol={{
            span: 24,
          }}
          initialValues={{
            title: '',
            description: '',
            marketing_approved: false,
            retail_approved: false,
            date_from: '',
            date_to: '',
            time_from: '',
            time_to: '',
            shopping_center_id: '',
            staff_only: false,
            evidence: false,
            contractor_ids: [],
            is_archive: false,
            is_newsletter: false,
            is_radio: false,
            is_social: false,
            is_web: false,
          }}
          layout={'vertical'}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete='off'
        >
          <InfoSection isView={isApproveOnly} form={form} />
          <DescriptionSection isView={isApproveOnly} form={form} />
          <ImagesSection
            isView={isApproveOnly}
            updateInProcess={updateInProcess}
            handleDeleteFile={handleDeleteFile}
            singleItem={singleItem}
            isEdit={!isNew}
          />

          <DateSection data={singleItem} isView={isApproveOnly} />
          <ShopSection
            companyCategories={filterData?.company_categories}
            shoppingCenters={filterData?.shopping_centers}
            shops={filterData?.companies || []}
            inactiveShops={filterData?.inactive_companies || []}
            isShoppingCenter={isShoppingCenter}
            isView={isApproveOnly}
          />
          <CheckboxesSection isView={isApproveOnly} />
          <CommunicationsCheckboxes data={singleItem} isView={isApproveOnly} />
          {!isApproveOnly && (
            <Row gutter={16}>
              <Col>
                <Button
                  onClick={onClickSave}
                  width={'150px'}
                  big
                  loading={updateInProcess}
                  icon={<CheckOutlined />}
                >
                  {t('Invia')}
                </Button>
              </Col>
            </Row>
          )}
          {!isNew && (
            <NotificationFormForEdit
              loading={updateInProcess}
              handleOnFinish={handleApprove}
              showApprove={!!singleItem.can_approve}
              showReject={!!singleItem.can_reject}
              showToAdim={!!singleItem.can_to_adim}
              showRefuse={!!singleItem.can_refuse}
              approveKey={'publish'}
              rejectKey={'unpublish'}
            />
          )}
        </Form>
      </div>
    </div>
  );
};

export default EditStoreEvent;
